import {
  GET_MERCHANTS,
  GET_MERCHANTS_FAIL,
  GET_MERCHANTS_SUCCESS,
  CLEAR_MERCHANTS,
  ADD_NEW_MERCHANT,
  ADD_NEW_MERCHANT_SUCCESS,
  ADD_NEW_MERCHANT_FAIL,
  GET_MERCHANT_DETAIL,
  GET_MERCHANT_DETAIL_SUCCESS,
  GET_MERCHANT_DETAIL_FAIL,
  CLEAR_MERCHANT_DETAIL,
  GET_MERCHANT_COMMUNICATIONS,
  GET_MERCHANT_COMMUNICATIONS_SUCCESS,
  GET_MERCHANT_COMMUNICATIONS_FAIL,
  CLEAR_MERCHANT_COMMUNICATIONS,
  MANAGE_MERCHANT_COMMUNICATION,
  MANAGE_MERCHANT_COMMUNICATION_SUCCESS,
  MANAGE_MERCHANT_COMMUNICATION_FAIL,
  GET_MERCHANT_CONTACTS,
  GET_MERCHANT_CONTACTS_SUCCESS,
  GET_MERCHANT_CONTACTS_FAIL,
  CLEAR_MERCHANT_CONTACTS,
  MANAGE_MERCHANT_CONTACT,
  MANAGE_MERCHANT_CONTACT_SUCCESS,
  MANAGE_MERCHANT_CONTACT_FAIL,
  GET_MERCHANT_CONTACT_COMMUNICATIONS,
  GET_MERCHANT_CONTACT_COMMUNICATIONS_SUCCESS,
  GET_MERCHANT_CONTACT_COMMUNICATIONS_FAIL,
  MANAGE_MERCHANT_CONTACT_COMMUNICATION,
  MANAGE_MERCHANT_CONTACT_COMMUNICATION_SUCCESS,
  MANAGE_MERCHANT_CONTACT_COMMUNICATION_FAIL,
  GET_MERCHANT_BANKING_DETAIL,
  GET_MERCHANT_BANKING_DETAIL_SUCCESS,
  GET_MERCHANT_BANKING_DETAIL_FAIL,
  CLEAR_MERCHANT_BANKING_DETAIL,
  ADD_NEW_MERCHANT_BANKING,
  ADD_NEW_MERCHANT_BANKING_SUCCESS,
  ADD_NEW_MERCHANT_BANKING_FAIL,
  SET_CONTACT_CREATION_STATE,
  CLEAR_CONTACT_CREATION_STATE,
  DELETE_MERCHANT,
  DELETE_MERCHANT_SUCCESS,
  DELETE_MERCHANT_FAIL,
  MANAGE_MERCHANT_BANKING,
  MANAGE_MERCHANT_BANKING_SUCCESS,
  MANAGE_MERCHANT_BANKING_FAIL,
  CHECK_MERCHANT_BANKING_STATUS,
  CHECK_MERCHANT_BANKING_STATUS_SUCCESS,
  CHECK_MERCHANT_BANKING_STATUS_FAIL,
  GET_MERCHANT_IMAGES,
  GET_MERCHANT_IMAGES_SUCCESS,
  GET_MERCHANT_IMAGES_FAIL,
  CLEAR_MERCHANT_IMAGES,
  MANAGE_MERCHANT_IMAGE,
  MANAGE_MERCHANT_IMAGE_SUCCESS,
  MANAGE_MERCHANT_IMAGE_FAIL,
  GET_MERCHANT_TIMINGS,
  GET_MERCHANT_TIMINGS_SUCCESS,
  GET_MERCHANT_TIMINGS_FAIL,
  CLEAR_MERCHANT_TIMINGS,
  MANAGE_MERCHANT_TIMING,
  MANAGE_MERCHANT_TIMING_SUCCESS,
  MANAGE_MERCHANT_TIMING_FAIL,
  GET_MERCHANT_ATTRIBUTES,
  GET_MERCHANT_ATTRIBUTES_SUCCESS,
  GET_MERCHANT_ATTRIBUTES_FAIL,
  CLEAR_MERCHANT_ATTRIBUTES,
  MANAGE_MERCHANT_ATTRIBUTE,
  MANAGE_MERCHANT_ATTRIBUTE_SUCCESS,
  MANAGE_MERCHANT_ATTRIBUTE_FAIL,
  ADD_ATTRIBUTE_TO_FORM,
  UPDATE_ATTRIBUTE_IN_FORM,
  REMOVE_ATTRIBUTE_FROM_FORM,
  CLEAR_ATTRIBUTE_FORM,
  GET_MERCHANT_TAGS,
  GET_MERCHANT_TAGS_SUCCESS,
  GET_MERCHANT_TAGS_FAIL,
  CLEAR_MERCHANT_TAGS,
  MANAGE_MERCHANT_TAG,
  MANAGE_MERCHANT_TAG_SUCCESS,
  MANAGE_MERCHANT_TAG_FAIL,
  GET_TAG_DEFINITIONS,
  GET_TAG_DEFINITIONS_SUCCESS,
  GET_TAG_DEFINITIONS_FAIL,
  CLEAR_TAG_DEFINITIONS,
  CLEAR_MERCHANT_VARIABLES,
  GET_MERCHANT_VARIABLES,
  GET_MERCHANT_VARIABLES_SUCCESS,
  GET_MERCHANT_VARIABLES_FAIL,
  CREATE_MERCHANT_VARIABLES,
  CREATE_MERCHANT_VARIABLES_SUCCESS,
  CREATE_MERCHANT_VARIABLES_FAIL,
  UPDATE_MERCHANT_VARIABLES,
  UPDATE_MERCHANT_VARIABLES_SUCCESS,
  UPDATE_MERCHANT_VARIABLES_FAIL,
  GET_RECONCILIATION_FREQUENCIES,
  GET_RECONCILIATION_FREQUENCIES_SUCCESS,
  GET_RECONCILIATION_FREQUENCIES_FAIL,
  CLEAR_RECONCILIATION_FREQUENCIES,
  ADD_TIMING_TO_FORM,
  UPDATE_TIMING_IN_FORM,
  REMOVE_TIMING_FROM_FORM,
  CLEAR_TIMING_FORM,
  CLEAR_TIMING_CREATION_SUCCESS,
  CLEAR_ATTRIBUTE_CREATION_SUCCESS,
  REORDER_MERCHANT_IMAGES,
  REORDER_MERCHANT_IMAGES_SUCCESS,
  REORDER_MERCHANT_IMAGES_FAIL,
  SET_LOCAL_IMAGES_ORDER,
  RESET_LOCAL_IMAGES_ORDER,
  GET_MERCHANT_PINS,
  GET_MERCHANT_PINS_SUCCESS,
  GET_MERCHANT_PINS_FAIL,
  CLEAR_MERCHANT_PINS,
  SHOW_MERCHANT_PINS,
  SHOW_MERCHANT_PINS_SUCCESS,
  SHOW_MERCHANT_PINS_FAIL,
  UPDATE_MERCHANT_PINS,
  UPDATE_MERCHANT_PINS_SUCCESS,
  UPDATE_MERCHANT_PINS_FAIL,
} from "./actionTypes"

const INIT_STATE = {
  merchants: [],
  merchantDetail: null,
  merchantCommunications: [],
  merchantContacts: [],
  merchantBankingDetail: null,
  merchantBanking: [],
  merchantTimings: [],
  commChannels: [],
  error: {},
  deleteError: null,
  communicationError: null,
  contactError: null,
  bankingError: null,
  timingError: null,
  isLoadingCommunications: false,
  isLoadingContacts: false,
  isLoadingBanking: false,
  isLoadingContactCommunications: false,
  isLoadingTimings: false,
  timingFormData: [],
  timingFormError: null,
  creationSuccess: null,
  bankingCreationSuccess: null,
  timingCreationSuccess: null,
  // Contact Communication Management
  merchantContactCommunications: [],
  contactCommunicationError: null,
  // Contact Creation State
  contactCreationState: {
    phase: "contact", // "contact" or "communication"
    currentContact: null,
    isContactReadOnly: false,
  },

  // Merchant Images
  merchantImages: [],
  imageError: null,
  isLoadingImages: false,
  localImages: [],
  hasOrderChanged: false,
  isReorderingImages: false,
  reorderError: null,

  // Merchant Attributes
  merchantAttributes: [],
  attributeError: null,
  isLoadingAttributes: false,
  attributeCreationSuccess: null,

  // Attribute form state
  attributeFormData: [],
  attributeFormError: null,

  // Merchant Tags
  merchantTags: [],
  tagError: null,
  isLoadingTags: false,
  tagManagementSuccess: null,

  // Tag Definitions
  tagDefinitions: [],
  definitionError: null,
  isLoadingDefinitions: false,
  merchantVariables: null,
  variablesError: null,
  variablesSuccess: null,
  isLoadingVariables: false,

  // Reconciliation Frequencies
  reconciliationFrequencies: [],
  reconciliationFrequenciesError: null,

  // Merchant PINs
  merchantPins: null,
  pinsError: null,
  showPinsError: null,
  isLoadingPins: false,
  isShowingPins: false,
  pinUpdateSuccess: null,
  isLoadingReconciliationFrequencies: false,
}
const sortImagesByDisplayOrder = (images) => {
  if (!Array.isArray(images)) return images;
  return [...images].sort((a, b) => {
    const orderA = parseInt(a.displayOrder) || 0;
    const orderB = parseInt(b.displayOrder) || 0;
    return orderA - orderB;
  });
};

const merchants = (state = INIT_STATE, action) => {
  switch (action.type) {
    // Merchants List
    case GET_MERCHANTS_SUCCESS:
      return {
        ...state,
        merchants: action.payload,
        error: {},
      }

    case GET_MERCHANTS_FAIL:
      return {
        ...state,
        error: action.payload,
      }

    case CLEAR_MERCHANTS:
      return {
        ...state,
        merchants: [],
        error: {},
      }

    // Add New Merchant
    case ADD_NEW_MERCHANT:
      return {
        ...state,
        error: {},
        creationSuccess: null,
      }

    case ADD_NEW_MERCHANT_SUCCESS:
      return {
        ...state,
        merchants: [...state.merchants, action.payload],
        creationSuccess: action.payload,
        error: {},
      }

    case ADD_NEW_MERCHANT_FAIL:
      return {
        ...state,
        error: action.payload,
        creationSuccess: null,
      }

    // Merchant Detail
    case GET_MERCHANT_DETAIL:
      return {
        ...state,
        error: {},
      }

    case GET_MERCHANT_DETAIL_SUCCESS:
      return {
        ...state,
        merchantDetail: action.payload,
        error: {},
      }

    case GET_MERCHANT_DETAIL_FAIL:
      return {
        ...state,
        error: action.payload,
      }

    case CLEAR_MERCHANT_DETAIL:
      return {
        ...state,
        merchantDetail: null,
        error: {},
      }

    // Merchant Communications
    case GET_MERCHANT_COMMUNICATIONS:
      return {
        ...state,
        isLoadingCommunications: true,
        communicationError: null,
      }

    case GET_MERCHANT_COMMUNICATIONS_SUCCESS:
      return {
        ...state,
        merchantCommunications: action.payload,
        isLoadingCommunications: false,
        communicationError: null,
      }

    case GET_MERCHANT_COMMUNICATIONS_FAIL:
      return {
        ...state,
        isLoadingCommunications: false,
        communicationError: action.payload,
      }

    case CLEAR_MERCHANT_COMMUNICATIONS:
      return {
        ...state,
        merchantCommunications: [],
        communicationError: null,
      }

    case MANAGE_MERCHANT_COMMUNICATION_SUCCESS:
      // Refresh communications list after successful operation
      return {
        ...state,
        communicationError: null,
      }

    case MANAGE_MERCHANT_COMMUNICATION_FAIL:
      return {
        ...state,
        communicationError: action.payload,
      }

    // Merchant Contacts
    case GET_MERCHANT_CONTACTS:
      return {
        ...state,
        isLoadingContacts: true,
        contactError: null,
      }

    case GET_MERCHANT_CONTACTS_SUCCESS:
      return {
        ...state,
        merchantContacts: action.payload,
        isLoadingContacts: false,
        contactError: null,
      }

    case GET_MERCHANT_CONTACTS_FAIL:
      return {
        ...state,
        isLoadingContacts: false,
        contactError: action.payload,
      }

    case CLEAR_MERCHANT_CONTACTS:
      return {
        ...state,
        merchantContacts: [],
        contactError: null,
      }

    case MANAGE_MERCHANT_CONTACT_SUCCESS:
      // Refresh contacts list after successful operation
      return {
        ...state,
        contactError: null,
      }

    case MANAGE_MERCHANT_CONTACT_FAIL:
      return {
        ...state,
        contactError: action.payload,
      }

    // Merchant Contact Communications
    case GET_MERCHANT_CONTACT_COMMUNICATIONS:
      return {
        ...state,
        isLoadingContactCommunications: true,
        contactCommunicationError: null,
      }

    case GET_MERCHANT_CONTACT_COMMUNICATIONS_SUCCESS:
      return {
        ...state,
        merchantContactCommunications: action.payload,
        isLoadingContactCommunications: false,
        contactCommunicationError: null,
      }

    case GET_MERCHANT_CONTACT_COMMUNICATIONS_FAIL:
      return {
        ...state,
        isLoadingContactCommunications: false,
        contactCommunicationError: action.payload,
      }

    case MANAGE_MERCHANT_CONTACT_COMMUNICATION_SUCCESS:
      return {
        ...state,
        contactCommunicationError: null,
      }

    case MANAGE_MERCHANT_CONTACT_COMMUNICATION_FAIL:
      return {
        ...state,
        contactCommunicationError: action.payload,
      }

    // Merchant Banking
    case GET_MERCHANT_BANKING_DETAIL:
      return {
        ...state,
        isLoadingBanking: true,
        bankingError: null,
      }

    case GET_MERCHANT_BANKING_DETAIL_SUCCESS:
      return {
        ...state,
        merchantBankingDetail: action.payload,
        merchantBanking: Array.isArray(action.payload) ? action.payload : (action.payload ? [action.payload] : []),
        isLoadingBanking: false,
        bankingError: null,
      }

    case GET_MERCHANT_BANKING_DETAIL_FAIL:
      return {
        ...state,
        isLoadingBanking: false,
        bankingError: action.payload,
      }

    case CLEAR_MERCHANT_BANKING_DETAIL:
      return {
        ...state,
        merchantBankingDetail: null,
        merchantBanking: [],
        bankingError: null,
      }

    case ADD_NEW_MERCHANT_BANKING:
      return {
        ...state,
        bankingError: null,
      }

    case ADD_NEW_MERCHANT_BANKING_SUCCESS:
      return {
        ...state,
        merchantBankingDetail: action.payload,
        merchantBanking: [...state.merchantBanking, action.payload],
        bankingCreationSuccess: action.payload,
        bankingError: null,
      }

    case ADD_NEW_MERCHANT_BANKING_FAIL:
      return {
        ...state,
        bankingError: action.payload,
      }

    // Manage Merchant Banking
    case MANAGE_MERCHANT_BANKING:
      return {
        ...state,
        bankingError: null,
      }

    case MANAGE_MERCHANT_BANKING_SUCCESS:
      return {
        ...state,
        merchantBanking: state.merchantBanking.map(banking =>
          banking.merchantBankingID === action.payload.merchantBankingID
            ? action.payload
            : banking
        ),
        bankingCreationSuccess: action.payload,
        bankingError: null,
      }

    case MANAGE_MERCHANT_BANKING_FAIL:
      return {
        ...state,
        bankingError: action.payload,
      }

    // Check Merchant Banking Status
    case CHECK_MERCHANT_BANKING_STATUS:
      return {
        ...state,
        bankingError: null,
      }

    case CHECK_MERCHANT_BANKING_STATUS_SUCCESS:
      return {
        ...state,
        merchantBanking: state.merchantBanking.map(banking =>
          banking.payoutProviderDestinationID === action.payload.destinationID
            ? { ...banking, payoutProviderDestinationStatus: action.payload.status }
            : banking
        ),
        bankingError: null,
      }

    case CHECK_MERCHANT_BANKING_STATUS_FAIL:
      return {
        ...state,
        bankingError: action.payload,
      }

    // Contact Creation State Management
    case SET_CONTACT_CREATION_STATE:
      return {
        ...state,
        contactCreationState: {
          ...state.contactCreationState,
          ...action.payload,
        },
      }

    case CLEAR_CONTACT_CREATION_STATE:
      return {
        ...state,
        contactCreationState: {
          phase: "contact",
          currentContact: null,
          isContactReadOnly: false,
        },
      }

    // Delete Merchant
    case DELETE_MERCHANT:
      return {
        ...state,
        deleteError: null,
      }

    case DELETE_MERCHANT_SUCCESS:
      return {
        ...state,
        deleteError: null,
      }

    case DELETE_MERCHANT_FAIL:
      return {
        ...state,
        deleteError: action.payload,
      }
    // Merchant Attributes
    case GET_MERCHANT_ATTRIBUTES:
      return {
        ...state,
        isLoadingAttributes: true,
        attributeError: null,
      }

    case GET_MERCHANT_ATTRIBUTES_SUCCESS:
      return {
        ...state,
        merchantAttributes: action.payload,
        isLoadingAttributes: false,
        attributeError: null,
      }

    case GET_MERCHANT_ATTRIBUTES_FAIL:
      return {
        ...state,
        isLoadingAttributes: false,
        attributeError: action.payload,
      }

    case CLEAR_MERCHANT_ATTRIBUTES:
      return {
        ...state,
        merchantAttributes: [],
        attributeError: null,
        attributeCreationSuccess: null,
      }

    case MANAGE_MERCHANT_ATTRIBUTE:
      return {
        ...state,
        attributeError: null,
      }

    case MANAGE_MERCHANT_ATTRIBUTE_SUCCESS:
      return {
        ...state,
        attributeCreationSuccess: action.payload,
        attributeError: null,
        attributeFormData: [],
      }

    case MANAGE_MERCHANT_ATTRIBUTE_FAIL:
      return {
        ...state,
        attributeError: action.payload,
      }

    case CLEAR_ATTRIBUTE_CREATION_SUCCESS:
      return {
        ...state,
        attributeCreationSuccess: null,
      }

    // Attribute form state management
    case ADD_ATTRIBUTE_TO_FORM:
      return {
        ...state,
        attributeFormData: [...state.attributeFormData, action.payload],
        attributeFormError: null,
      }

    case UPDATE_ATTRIBUTE_IN_FORM:
      return {
        ...state,
        attributeFormData: state.attributeFormData.map((attr, index) =>
          index === action.payload.index ? action.payload.attribute : attr
        ),
        attributeFormError: null,
      }

    case REMOVE_ATTRIBUTE_FROM_FORM:
      return {
        ...state,
        attributeFormData: state.attributeFormData.filter(
          (_, index) => index !== action.payload
        ),
        attributeFormError: null,
      }

    case CLEAR_ATTRIBUTE_FORM:
      return {
        ...state,
        attributeFormData: [],
        attributeFormError: null,
      }


    // Merchant Timings
    case GET_MERCHANT_TIMINGS:
      return {
        ...state,
        isLoadingTimings: true,
        timingError: null,
      }

    case GET_MERCHANT_TIMINGS_SUCCESS:
      return {
        ...state,
        merchantTimings: action.payload,
        isLoadingTimings: false,
        timingError: null,
      }

    case GET_MERCHANT_TIMINGS_FAIL:
      return {
        ...state,
        merchantTimings: [],
        isLoadingTimings: false,
        timingError: action.payload,
      }

    case CLEAR_MERCHANT_TIMINGS:
      return {
        ...state,
        merchantTimings: [],
        timingError: null,
        timingCreationSuccess: null,
      }

    case MANAGE_MERCHANT_TIMING:
      return {
        ...state,
        timingError: null,
      }

    case MANAGE_MERCHANT_TIMING_SUCCESS:
      return {
        ...state,
        timingCreationSuccess: action.payload,
        timingError: null,
        timingFormData: [],
      }

    case MANAGE_MERCHANT_TIMING_FAIL:
      return {
        ...state,
        timingError: action.payload,
        timingCreationSuccess: null,
      }
    case ADD_TIMING_TO_FORM:
      return {
        ...state,
        timingFormData: [...state.timingFormData, action.payload],
        timingFormError: null,
      }

    case UPDATE_TIMING_IN_FORM:
      return {
        ...state,
        timingFormData: state.timingFormData.map((timing, index) =>
          index === action.payload.index ? action.payload.timing : timing
        ),
        timingFormError: null,
      }

    case REMOVE_TIMING_FROM_FORM:
      return {
        ...state,
        timingFormData: state.timingFormData.filter(
          (_, index) => index !== action.payload
        ),
        timingFormError: null,
      }

    case CLEAR_TIMING_FORM:
      return {
        ...state,
        timingFormData: [],
        timingFormError: null,
      }
    case CLEAR_TIMING_CREATION_SUCCESS:
      return {
        ...state,
        timingCreationSuccess: null,
      }

    // Merchant Images
    case GET_MERCHANT_IMAGES:
      return {
        ...state,
        isLoadingImages: true,
        imageError: null,
      }

    case GET_MERCHANT_IMAGES_SUCCESS:
      const sortedImages = sortImagesByDisplayOrder(action.payload);
      return {
        ...state,
        merchantImages: sortedImages,
        localImages: sortedImages,
        isLoadingImages: false,
        imageError: null,
        hasOrderChanged: false
      }

    case GET_MERCHANT_IMAGES_FAIL:
      return {
        ...state,
        isLoadingImages: false,
        imageError: action.payload,
      }

    case CLEAR_MERCHANT_IMAGES:
      return {
        ...state,
        merchantImages: [],
        imageError: null,
      }

    case MANAGE_MERCHANT_IMAGE:
      return {
        ...state,
        imageError: null,
      }

    case MANAGE_MERCHANT_IMAGE_SUCCESS:
      return {
        ...state,
        imageError: null,
      }

    case MANAGE_MERCHANT_IMAGE_FAIL:
      return {
        ...state,
        imageError: action.payload,
      }

    // Reorder Merchant Images
    case REORDER_MERCHANT_IMAGES:
      return {
        ...state,
        isReorderingImages: true,
        reorderError: null,
      }

    case REORDER_MERCHANT_IMAGES_SUCCESS:
      return {
        ...state,
        isReorderingImages: false,
        reorderError: null,
        hasOrderChanged: false,
      }

    case REORDER_MERCHANT_IMAGES_FAIL:
      return {
        ...state,
        isReorderingImages: false,
        reorderError: action.payload,
      }

    // Local images order management
    case SET_LOCAL_IMAGES_ORDER:
      return {
        ...state,
        localImages: action.payload,
        hasOrderChanged: true,
      }

    case RESET_LOCAL_IMAGES_ORDER:
      return {
        ...state,
        localImages: sortImagesByDisplayOrder([...state.merchantImages]),
        hasOrderChanged: false,
      }

    // Merchant Tags Cases
    case GET_MERCHANT_TAGS:
      return {
        ...state,
        isLoadingTags: true,
        tagError: null,
      }

    case GET_MERCHANT_TAGS_SUCCESS:
      return {
        ...state,
        merchantTags: action.payload,
        isLoadingTags: false,
        tagError: null,
      }

    case GET_MERCHANT_TAGS_FAIL:
      return {
        ...state,
        isLoadingTags: false,
        tagError: action.payload,
      }

    case CLEAR_MERCHANT_TAGS:
      return {
        ...state,
        merchantTags: [],
        tagError: null,
      }

    case MANAGE_MERCHANT_TAG:
      return {
        ...state,
        tagError: null,
        tagManagementSuccess: null,
      }

    case MANAGE_MERCHANT_TAG_SUCCESS:
      return {
        ...state,
        tagError: null,
        tagManagementSuccess: action.payload,
      }

    case MANAGE_MERCHANT_TAG_FAIL:
      return {
        ...state,
        tagError: action.payload,
        tagManagementSuccess: null,
      }

    // Tag Definitions Cases
    case GET_TAG_DEFINITIONS:
      return {
        ...state,
        isLoadingDefinitions: true,
        definitionError: null,
      }

    case GET_TAG_DEFINITIONS_SUCCESS:
      return {
        ...state,
        tagDefinitions: action.payload,
        isLoadingDefinitions: false,
        definitionError: null,
      }

    case GET_TAG_DEFINITIONS_FAIL:
      return {
        ...state,
        isLoadingDefinitions: false,
        definitionError: action.payload,
      }

    case CLEAR_TAG_DEFINITIONS:
      return {
        ...state,
        tagDefinitions: [],
        definitionError: null,
      }

    case GET_MERCHANT_VARIABLES:
      return {
        ...state,
        isLoadingVariables: true,
        variablesError: null,
      }

    case GET_MERCHANT_VARIABLES_SUCCESS:
      return {
        ...state,
        merchantVariables: action.payload,
        isLoadingVariables: false,
        variablesError: null,
      }

    case GET_MERCHANT_VARIABLES_FAIL:
      return {
        ...state,
        isLoadingVariables: false,
        variablesError: action.payload,
      }

    case CREATE_MERCHANT_VARIABLES:
    case UPDATE_MERCHANT_VARIABLES:
      return {
        ...state,
        isLoadingVariables: true,
        variablesError: null,
        variablesSuccess: null,
      }

    case CREATE_MERCHANT_VARIABLES_SUCCESS:
    case UPDATE_MERCHANT_VARIABLES_SUCCESS:
      return {
        ...state,
        merchantVariables: action.payload,
        variablesSuccess: action.payload,
        variablesError: null,
        isLoadingVariables: false,
      }

    case CREATE_MERCHANT_VARIABLES_FAIL:
    case UPDATE_MERCHANT_VARIABLES_FAIL:
      return {
        ...state,
        variablesError: action.payload,
        variablesSuccess: null,
        isLoadingVariables: false,
      }

    case CLEAR_MERCHANT_VARIABLES:
      return {
        ...state,
        merchantVariables: null,
        variablesError: null,
        variablesSuccess: null,
        isLoadingVariables: false,
      }

    case GET_RECONCILIATION_FREQUENCIES:
      return {
        ...state,
        isLoadingReconciliationFrequencies: true,
        reconciliationFrequenciesError: null,
      }

    case GET_RECONCILIATION_FREQUENCIES_SUCCESS:
      return {
        ...state,
        reconciliationFrequencies: action.payload,
        isLoadingReconciliationFrequencies: false,
        reconciliationFrequenciesError: null,
      }

    case GET_RECONCILIATION_FREQUENCIES_FAIL:
      return {
        ...state,
        reconciliationFrequenciesError: action.payload,
        isLoadingReconciliationFrequencies: false,
      }

    case CLEAR_RECONCILIATION_FREQUENCIES:
      return {
        ...state,
        reconciliationFrequencies: [],
        reconciliationFrequenciesError: null,
        isLoadingReconciliationFrequencies: false,
      }

    // Merchant PINs Cases
    case GET_MERCHANT_PINS:
      return {
        ...state,
        isLoadingPins: true,
        pinsError: null,
      }

    case GET_MERCHANT_PINS_SUCCESS:
      return {
        ...state,
        merchantPins: action.payload,
        isLoadingPins: false,
        pinsError: null,
      }

    case GET_MERCHANT_PINS_FAIL:
      return {
        ...state,
        isLoadingPins: false,
        pinsError: action.payload,
      }

    case SHOW_MERCHANT_PINS:
      return {
        ...state,
        isShowingPins: true,
        showPinsError: null,
      }

    case SHOW_MERCHANT_PINS_SUCCESS:
      return {
        ...state,
        merchantPins: action.payload,
        isShowingPins: false,
        showPinsError: null,
      }

    case SHOW_MERCHANT_PINS_FAIL:
      return {
        ...state,
        isShowingPins: false,
        showPinsError: action.payload,
      }

    case UPDATE_MERCHANT_PINS:
      return {
        ...state,
        isLoadingPins: true,
        pinsError: null,
        pinUpdateSuccess: null,
      }

    case UPDATE_MERCHANT_PINS_SUCCESS:
      return {
        ...state,
        merchantPins: action.payload,
        isLoadingPins: false,
        pinsError: null,
        pinUpdateSuccess: action.payload,
      }

    case UPDATE_MERCHANT_PINS_FAIL:
      return {
        ...state,
        isLoadingPins: false,
        pinsError: action.payload,
        pinUpdateSuccess: null,
      }

    case CLEAR_MERCHANT_PINS:
      return {
        ...state,
        merchantPins: null,
        pinsError: null,
        showPinsError: null,
        isLoadingPins: false,
        isShowingPins: false,
        pinUpdateSuccess: null,
      }

    default:
      return { ...state }
  }
}

export default merchants